module.exports = __webpack_public_path__ + "img/STADA-TR-Logo-white.238e4569.svg";